module.exports = __webpack_public_path__ + "static/tischler-logo-939f826321736980bb2152525750acd1.jpg";